// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    font-family: Arial, sans-serif;
}
  
.container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
}

.navbar {
    width: 100%;
    padding: 1rem;
    background-color: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: flex-end;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    position: fixed;
    top: 0;
}

.logo {
    font-size: 1.5rem;
    font-weight: bold;
    position: relative;
    right: 5vh;
}

.form-container {
    background-color: rgba(255, 255, 255, 0.3);
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;
    text-align: center;
    margin-top: 10vh;
}

.heading {
    margin-bottom: 1.5rem;
    color: black;
    font-size: 2rem;
}

.error {
    color: red;
    margin-bottom: 1rem;
}

.forgot-password {
    display: block;
    margin-top: 0.5rem;
    font-size: 0.8rem;
    color: #007bff;
    text-align: right;
    text-decoration: none;
}

.forgot-password:hover {
    text-decoration: underline;
}

.button {
    width: 100%;
    padding: 0.75rem;
    border-radius: 4px;
    border: none;
    background-color: #007bff;
    color: white;
    font-size: 1rem;
    cursor: pointer;
}

.button:hover {
    background-color: #0056b3;
}

/* Text input field styles */
.MuiFormControl-root {
    margin-bottom: 15px;
    width: 100%;
}

.MuiInputBase-root input {
    padding: 10px;
}

.MuiIconButton-root {
    color: #007bff;
}

/* Divider styling */
.MuiDivider-root {
    margin-top: 20px;
    margin-bottom: 20px;
}

/* Button styles for Google login */
.MuiButton-outlined {
    color: #007bff;
    border-color: #007bff;
}

.MuiButton-outlined:hover {
    border-color: #0056b3;
    color: #0056b3;
}

/* Register link style */
.register-link {
    margin-top: 20px;
    text-align: center;
    font-size: 0.9rem;
}

.register-link a {
    color: #007bff;
    text-decoration: none;
}

.register-link a:hover {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Signin.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,yDAAuC;IACvC,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,0CAA0C;IAC1C,aAAa;IACb,yBAAyB;IACzB,wCAAwC;IACxC,eAAe;IACf,MAAM;AACV;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,0CAA0C;IAC1C,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,4BAA4B;AAC5B;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,mCAAmC;AACnC;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":["body, html {\n    margin: 0;\n    padding: 0;\n    height: 100%;\n    width: 100%;\n    font-family: Arial, sans-serif;\n}\n  \n.container {\n    background-image: url('background.jpg');\n    background-size: cover;\n    background-position: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n}\n\n.navbar {\n    width: 100%;\n    padding: 1rem;\n    background-color: rgba(255, 255, 255, 0.5);\n    display: flex;\n    justify-content: flex-end;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    position: fixed;\n    top: 0;\n}\n\n.logo {\n    font-size: 1.5rem;\n    font-weight: bold;\n    position: relative;\n    right: 5vh;\n}\n\n.form-container {\n    background-color: rgba(255, 255, 255, 0.3);\n    padding: 2rem;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    max-width: 400px;\n    text-align: center;\n    margin-top: 10vh;\n}\n\n.heading {\n    margin-bottom: 1.5rem;\n    color: black;\n    font-size: 2rem;\n}\n\n.error {\n    color: red;\n    margin-bottom: 1rem;\n}\n\n.forgot-password {\n    display: block;\n    margin-top: 0.5rem;\n    font-size: 0.8rem;\n    color: #007bff;\n    text-align: right;\n    text-decoration: none;\n}\n\n.forgot-password:hover {\n    text-decoration: underline;\n}\n\n.button {\n    width: 100%;\n    padding: 0.75rem;\n    border-radius: 4px;\n    border: none;\n    background-color: #007bff;\n    color: white;\n    font-size: 1rem;\n    cursor: pointer;\n}\n\n.button:hover {\n    background-color: #0056b3;\n}\n\n/* Text input field styles */\n.MuiFormControl-root {\n    margin-bottom: 15px;\n    width: 100%;\n}\n\n.MuiInputBase-root input {\n    padding: 10px;\n}\n\n.MuiIconButton-root {\n    color: #007bff;\n}\n\n/* Divider styling */\n.MuiDivider-root {\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n/* Button styles for Google login */\n.MuiButton-outlined {\n    color: #007bff;\n    border-color: #007bff;\n}\n\n.MuiButton-outlined:hover {\n    border-color: #0056b3;\n    color: #0056b3;\n}\n\n/* Register link style */\n.register-link {\n    margin-top: 20px;\n    text-align: center;\n    font-size: 0.9rem;\n}\n\n.register-link a {\n    color: #007bff;\n    text-decoration: none;\n}\n\n.register-link a:hover {\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
